'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BlueTextButton = require('./components/BlueTextButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlueTextButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/blue-text-button/index.js
// module id = 344
// module chunks = 0 1 2 3 4 5 6 7 8 9 10